import { useEffect, useState } from "react";
import { appCRUD } from "../../../actions/app";
import { TableShared } from "../../../shared";
import { char } from "../../../utils";
import { Button, Dropdown, Space } from "antd";
import { MoreOutlined, EyeOutlined } from "@ant-design/icons";
import { useNotification } from "../../../utils/notificationProvider";
import { TimeTableView } from "./timetable";
import { TimeTableAdd } from "./add";

export const TimeTableContent = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [dataId, setDataId] = useState(null);
  const [index, setIndex] = useState(0);
  const openNotification = useNotification();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      appCRUD
        .loadTimeTable(postsPerPage, nextPage, value, "-id")
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          openNotification(
            "error",
            "Error",
            <>
              Sorry...!
              <br />
              {error.message}
            </>
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 50,
    },
    {
      key: "campas",
      title: "Campas",
      dataIndex: "campas",
      sortable: true,
      width: 200,
    },
    {
      key: "academic",
      title: "Academic Year",
      dataIndex: "academic",
      sortable: true,
      width: 150,
    },
    {
      key: "semister",
      title: "Semester",
      dataIndex: "semister",
      sortable: true,
      width: 150,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 80,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 50,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <EyeOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                  setDataId(record.id);
                  setOpenView(true);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    campas: dt.cumpas ? char.toTitleCase(dt.cumpas.name) : "N/A",
    academic: dt.academic ? char.toTitleCase(dt.academic.name) : "N/A",
    semister: dt.semister ? char.toTitleCase(dt.semister.name) : "N/A",
    status: dt?.is_active ? (
      <span className="badge badge-soft-success badge-border">{"Active"}</span>
    ) : (
      <span className="badge badge-soft-danger badge-border">{"Inactive"}</span>
    ),
  }));

  

  const button = (
    <button
      className="btn btn-primary bg-gradient btn-border"
      onClick={() => setOpen(true)}
    >
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Table
    </button>
  );

  return (
    <>
      <TimeTableView open={openView} setOpen={setOpenView} dataId={dataId} />
      <TimeTableAdd
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Time Table</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={button}
          link={"#"}
          showButton={true}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
